export default __webpack_public_path__ + "static/1129-81a5f1748e03ea3b42676f5f3aed475e.gif";